import React, { useContext, useEffect, useMemo, useState } from 'react';
import KPICardsComponent from '../../KPICardsComponent/KPICardsComponent';
import SimulationFilter from 'components/atoms/SimulationFilter';
import { getPortfolioUpdateColumns } from 'utils/getPriceSimulatorColumns';
import AddMissingPPGModal from '../../Modals/AddMissingPPGModal';
import { priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
import MoreInfoTable from '../../MoreInfoTable/MoreInfoTable';
import { colorConstants } from 'config/colorConstants';
import { Table } from 'antd';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import DownloadExcel from 'components/molecules/MicroIntractions/DownloadExcel';
import { priceSimulatorPortfolioUpdateKpis } from 'parser/graphToExcelDownloadParser';
import { FilterContextData } from 'contexts/FilterContext';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PSR_PROTFOLIO_ADD_CELL_CLICKED, PSR_PROTFOLIO_CELL_CLICKED } from 'utils/mixpanelEventNames';

const PortfolioUpdateStep = () => {
    const {
        portfolioUpdateKpisData,
        changedPortfolioUpdateKpisLoading,
        portfolioUpdateKpisLoading,
        expandedRowKeys,
        setExpandedRowKeys,
        expandedRowDetails,
        setExpandedRowDetails,
        setAddNewPPGDetails,
        viewMode,
        portfolioUpdateSubmitClick,
        hasPortfolioKpisUpdated,
    } = useContext(priceSimulatorDataContext);
    const { allDimAndAttributeTypeList, idForRestOfComponentLoading } = useContext(FilterContextData);

    const [addNewPPGModalVisible, setAddNewPPGModalVisible] = useState(false);
    const [isEditPopUpMode, setIsEditPopUpMode] = useState(false);

    const onCellClickhandler = (columnName: string, rowData: any) => {
        if (expandedRowDetails.rowIndex === rowData.key && expandedRowDetails.columnName === columnName) {
            resetExpandedRowKeys();
        } else {
            setExpandedRowKeys([rowData.key]);
            setExpandedRowDetails({ columnName: columnName, rowName: rowData.label, rowIndex: rowData.key });
            trackEventMixpanel(PSR_PROTFOLIO_CELL_CLICKED, {
                rowName: rowData.label,
                colName: columnName,
            });
        }
    };

    const resetExpandedRowKeys = () => {
        setExpandedRowKeys([]);
        setExpandedRowDetails({ columnName: '', rowName: '', rowIndex: -1 });
    };

    const onAddClickhandler = (columnName: string, rowData: any, rowIndex: number) => {
        setAddNewPPGDetails({ columnName: columnName, rowName: rowData.label, rowIndex: rowIndex });
        setAddNewPPGModalVisible(true);
        trackEventMixpanel(PSR_PROTFOLIO_ADD_CELL_CLICKED, {
            rowName: rowData.label,
            colName: columnName,
        });
    };

    const portfoliooUpdateKpiMemoisedColumns = useMemo(() => {
        return getPortfolioUpdateColumns(
            portfolioUpdateKpisData,
            ['key', 'kpiList'],
            '',
            onCellClickhandler,
            onAddClickhandler,
            expandedRowDetails,
            viewMode,
        );
    }, [portfolioUpdateKpisData, expandedRowDetails]);

    const portfoliooUpdateKpiMemoisedHeaders = useMemo(() => {
        return portfolioUpdateKpisData && Array.isArray(portfolioUpdateKpisData) && portfolioUpdateKpisData.length > 0
            ? Object.keys(portfolioUpdateKpisData?.[0]).filter((k: string) => !['key', 'kpiList'].includes(k))
            : [];
    }, [portfolioUpdateKpisData]);

    const closeModal = () => {
        setAddNewPPGModalVisible(false);
        setIsEditPopUpMode(false);
    };

    const onEditClickHandler = () => {
        setIsEditPopUpMode(true);
        setAddNewPPGModalVisible(true);
    };
    const commonLoading =
        portfolioUpdateKpisLoading ||
        changedPortfolioUpdateKpisLoading ||
        allDimAndAttributeTypeList?.loading ||
        idForRestOfComponentLoading;

    return (
        <>
            <SimulationFilter />
            {/* KPI tiles component */}
            <KPICardsComponent />

            <div className="flex justify-between mt-5 items-center">
                <div className="font-md my-4 font-medium">Portfolio Update </div>
                <div className="flex">
                    {/* <PriceSimulatorLegends /> */}
                    {/* TODO : will be added in future */}
                    <div className="ml-4">
                        {/* <button className="rounded  px-4 py-1 border font-semibold cursor-pointer border-purpleFont  bg-purpleFont text-white mr-2">
                            + Add PPG
                        </button>
                        <button className="rounded  px-4 py-1 border font-semibold cursor-pointer border-purpleFont  bg-purpleFont text-white mr-2">
                            + Add Retailer
                        </button> */}
                        <button
                            onClick={() => portfolioUpdateSubmitClick()}
                            className={`rounded  py-2 px-4 border font-semibold  text-center  ${
                                hasPortfolioKpisUpdated
                                    ? 'cursor-pointer border-purpleFont  bg-purpleFont text-white'
                                    : 'cursor-not-allowed border-borderGrey bg-borderGrey text-promoColour'
                            }`}
                            disabled={portfolioUpdateKpisLoading || !hasPortfolioKpisUpdated}
                            id="price-sim-update-kpis-submit-btn"
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </div>

            <div className="flex justify-between">
                <div className="mb-2 font-xs text-promoColour">
                    In this page you can add or remove ppg mapped to a particular retailer.
                </div>
                <DownloadExcel
                    title={'PortfolioUpdate'}
                    excelData={priceSimulatorPortfolioUpdateKpis(
                        portfolioUpdateKpisData,
                        portfoliooUpdateKpiMemoisedHeaders,
                    )}
                    headers={portfoliooUpdateKpiMemoisedHeaders}
                    excludeFilters={true}
                />
            </div>
            <CustomTablePortfolioUpdate
                bordered
                style={{
                    opacity: commonLoading ? '0.5' : 1,
                    pointerEvents: commonLoading ? 'none' : 'auto',
                }}
                columns={portfoliooUpdateKpiMemoisedColumns}
                expandable={{
                    columnWidth: 0,
                    expandedRowRender: (record) => (
                        <MoreInfoTable onCloseIconClick={resetExpandedRowKeys} onEditClick={onEditClickHandler} />
                    ),
                    expandIcon: () => null,
                    expandedRowKeys: expandedRowKeys,
                }}
                pagination={false}
                scroll={{ x: '100%', y: 400 }}
                className="mb-2"
                sticky
                loading={commonLoading}
                dataSource={portfolioUpdateKpisData}
                id="price-sim-portfolio-update-table"
            />

            <AddMissingPPGModal visible={addNewPPGModalVisible} closeModal={closeModal} isEditMode={isEditPopUpMode} />
        </>
    );
};

export default PortfolioUpdateStep;

export const CustomTablePortfolioUpdate = styled(Table)`
    .ant-table-sticky-scroll {
        position: static;
        display: none;
    }
    .ant-table-thead > tr > th {
        background: ${colorConstants.grey};
        padding: 0px;
        height: 68px;
    }
    .ant-table-header col:not(:last-child),
    .ant-table-thead
        > tr
        > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not(
            [colspan]
        ):before {
        background: none;
    }
    .ant-table-column-sorter {
        position: relative;
        left: -10px;
    }
    .ant-table-column-sorter-down.active,
    .ant-table-column-sorter-up.active {
        ${tw`text-purpleFont`};
    }

    border: ${'1px solid #DBDFE9'};
`;
